module.exports = __webpack_public_path__ + "static/media/funding-rate.2eb6835c.jpg";